import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const LeaveType = (props) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.login);
  const language = useSelector((state)=> state.languages?.data)

  const [attributes] = useState(() => {
    const baseAttributes = [
      {
        type: "title",
        tab: "generalSettings",
        title: "generalSettings",
        required: false,
        view: false,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "de",
        name: "de",
        validation: "",
        default: "",
        label: "de",
        // showItem: "title",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "en",
        name: "en",
        validation: "",
        default: "",
        label: "en",
        // showItem: "title",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "userDefinedId",
        name: "userDefinedId",
        validation: "",
        default: "",
        label: "userDefinedId",
        // showItem: "title",
        required: false,
        view: true,
        add: true,
        update: true,
      },
      // {
      //   type: "text",
      //   placeholder: "de",
      //   name: "de",
      //   validation: "",
      //   default: "",
      //   label: "de",
      //   showItem: "title",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      {
        type: "color",
        placeholder: "color",
        name: "color",
        validation: "",
        default: "#000000",
        label: "color",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "title",
        tab: "proofAndRepresentation",
        title: "proofAndRepresentation",
        required: false,
        view: false,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "proof",
        name: "proof",
        validation: "",
        default: "",
        label: "proof",
        // showItem: "title",
        required: true,
        view: true,
        add: true,
        update: true,
        apiType: "JSON",
      selectApi: [
        { id: "required", value: t("proofRequired") },
        { id: "not-required", value: t("not-necessary") },
      ],
      },
      {
        type: "number",
        placeholder: "proofRequiredDays",
        name: "proofRequiredDays",
        validation: "",
        default: "",
        label: "proofRequiredDays",
        condition: { item: "proof", if: "required", then: "enabled", else: "disabled" },
        required: true,
        view: false,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "representation",
        name: "representation",
        validation: "",
        default: "",
        label: "representation",
        // showItem: "title",
        required: true,
        view: true,
        add: true,
        update: true,
        apiType: "JSON",
      selectApi: [
        { id: "required", value: t("proofRequired") },
        { id: "not-required", value: t("not-required") },
        { id: "optional", value: t("optional") },
      ],
      },
    ];

    if (language.length > 0) {
      const newAttributes = language
        ?.filter((val) => val?.id?.toLowerCase() !== "de" && val?.id?.toLowerCase() !== "en")
        ?.map((item) => ({
          type: "text",
          placeholder: item.id?.toLowerCase(),
          name: item.id?.toLowerCase(),
          validation: "",
          default: "",
          label: item.id?.toLowerCase(),
          required: false,
          view: false,
          add: true,
          update: true,
        }));
    
      // Insert newAttributes after the second position (index 2) in baseAttributes
      if (newAttributes.length > 0) {
        baseAttributes.splice(2, 0, ...newAttributes);
      }
    }
    
  
    // If the user's role is "super", add the "en" object to the array
    // if (user.data?.user?.role === "super") {
    //   baseAttributes.unshift({
    //     type: "text",
    //     placeholder: "en",
    //     name: "en",
    //     validation: "",
    //     default: "",
    //     label: "en",
    //     showItem: "title",
    //     required: true,
    //     view: true,
    //     add: true,
    //     update: true,
    //   });
    // }
  
    return baseAttributes;
  });

  //to update the page title
  useEffect(() => {
    document.title = `${t("leaveType")} - PersoBase`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable {...props} api={`leave-type`} itemTitle={`title`} shortName={`leaveType`} addPrivilege={true} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(LeaveType);
